import React from "react";
import Combines from "./index";

function AdminCombine() {
  return <Combines />;
}

export default AdminCombine;
